export default __webpack_public_path__ + "static/media/carbon-neutral.faf8f447.0ca2f8c7.svg";